<template>
    <div>
        <div style="width: 68%; margin: 20rem auto 50rem">
            <div class="smtitle">Excellent project</div>
            <div class="bigtitle" style="display: flex; align-items: center; justify-content: space-between">
                精品工程
                <router-link class="mores" to="/boutiquedetails" @click="godetails(aboutinfo.id)">
                    查看更多
                    <div>
                        <img src="../../static/images/link.png" />
                    </div>
                </router-link>
            </div>
        </div>
        <!--  -->
        <div class="boutique_img">
            <div class="boutique_box">
                <div class="boutique_img_box1" v-for="(item, index) in datainfo" :key="index">
                    <router-link to="/boutiquedetails">
                        <!-- <img src="/static/images/boutique5.png" alt="" /> -->
                        <img :src="golaburl + item.address" class="boutiquedetails_img" />
                    </router-link>
                    <!-- 鼠标经过显示标题 -->
                    <div class="culture_details">
                        <div>{{ item.coverWord }}</div>
                        <div @click="boutiquedetails3d">
                            <router-link
                                :to="{ path: '/boutiquedetails', query: { currentPage: 1 } }"
                                style="color: #0e6eb8"
                                >查看更多</router-link
                            >
                            <img src="../../static/images/culture_icon.png" alt="" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="boutique_box2">
                <div style="display: flex; justify-content: space-around">
                    <div class="boutique_img_box2" v-for="(item, index) in datainfo2" :key="index">
                        <router-link to="/boutiquedetails">
                            <!-- <img src="/static/images/boutique7.png" alt="" /> -->
                            <img :src="golaburl + item.address" class="boutiquedetails_img" />
                        </router-link>
                        <!-- 鼠标经过显示标题 -->
                        <div class="culture_details2">
                            <div>{{ item.coverWord }}</div>
                            <div @click="boutiquedetails3d">
                                <router-link to="/boutiquedetails" style="color: #0e6eb8">查看更多</router-link>
                                <img src="../../static/images/culture_icon.png" alt="" />
                            </div>
                        </div>
                    </div>
                </div>
                <div v-for="(item, index) in datainfo3" :key="index" class="last_box_img">
                    <router-link to="/boutiquedetails">
                        <img :src="golaburl + item.address" class="boutiquedetails_img" />
                    </router-link>
                    <!-- 鼠标经过显示标题 -->
                    <div class="culture_details2">
                        <div>{{ item.coverWord }}</div>
                        <div @click="boutiquedetails3d">
                            <router-link to="/boutiquedetails" style="color: #0e6eb8">查看更多</router-link>
                            <img src="../../static/images/culture_icon.png" alt="" />
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div class="boutique_box2">
                <div class="boutique_img_box2" v-for="(item, index) in datainfo3" :key="index">
                    <router-link to="/boutiquedetails">
                        <img :src="golaburl + item.address" class="boutiquedetails_img" />
                    </router-link>
                </div>
            </div> -->
        </div>
    </div>
</template>

<script>
import { getindex } from '@/api/api';
import { getindexExcellentProjecct } from '@/api/api';
import { getnewindex } from '@/api/api';

export default {
    data() {
        return {
            golaburl: 'http://39.101.74.19:8717/base-admin',
            datainfo: [],
            datainfo2: [],
            datainfo3: [],
            aboutinfo: [],
            btlist: [],
            ascription: 'boutiqueProjectCover',
        };
    },
    mounted() {
        this.getinfo();
    },
    methods: {
        boutiquedetails3d() {
            this.$router.push({
                path: '/boutiquedetails',
            });
        },
        godetails(data) {
            this.$router.push({ path: '/details', query: { type: data } });
        },
        group(array, subGroupLength) {
            let index = 0;
            let newArray = [];
            while (index < array.length) {
                newArray.push(array.slice(index, (index += subGroupLength)));
            }
            return newArray;
        },

        // 获取数据
        async getinfo() {
            const res = await getnewindex(this.ascription, 1, 5);
            if (res.code == 200) {
                // console.log('resres-----', res);
                // this.datainfo = this.group(res.firstList.slice(7, 12), 5);
                this.datainfo = res.data.slice(0, 2);

                this.datainfo2 = res.data.slice(2, 4);
                this.datainfo3 = res.data.slice(4, 5);
                // this.aboutinfo = res.firstList[res.firstList.length - 1];
                // this.aboutinfo = res.firstList[4];
                // console.log('this.aboutinfo===', this.aboutinfo);
            }
        },
    },
    //用完后记得将存储的锚点置空，否则会影响其他页面跳转到当前页面
    destroyed() {
        localStorage.setItem('toId', '');
    },
};
</script>

<style lang="scss" scoped>
@media screen and (max-width: 1024px) {
    .boutique_img_box2 {
        height: 210rem !important;
    }
}
@media screen and (max-width: 800px) {
    .boutique_img {
        width: 69%;
        height: 380rem;
        margin: 0 auto;
        display: flex;
        margin-bottom: 50px;
        justify-content: space-between;
        flex-wrap: wrap;
    }

    .boutique_box2[data-v-423ee37e] {
        width: 50%;
        display: flex;
        margin: 0 auto;
        align-content: space-between;
        justify-content: space-between;
        flex-direction: column;
    }
}
.boutiquedetails_img:hover {
    filter: brightness(0.8);
    cursor: pointer;
}
.boutiquedetails_img {
    transition: all 0.4s;
}
.boutiquedetails_img:hover {
    transform: scale(1.2);
}
.culture_details {
    font-weight: Bold;
    width: 213rem;
    height: 187rem;
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    justify-content: space-around;
    position: absolute;
    left: 15%;
    bottom: 28%;
    display: none;
    // background-color: pink;
    > div:nth-child(1) {
        display: flex;
        font-size: 38rem;
        color: #ffffff;
    }
    > div:nth-child(2) {
        background-color: #ffffff;
        color: #0e6eb8;
        border-radius: 8px;
        font-size: 16rem;
        // width: 152rem;
        width: 70%;
        height: 58px;
        display: flex;
        justify-content: space-evenly;
        align-items: center;
        margin-top: 30rem;
    }
}
.culture_details2 {
    font-weight: Bold;
    width: 118rem;
    height: 86rem;
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    justify-content: space-around;
    position: absolute;
    left: 15%;
    bottom: 20%;
    display: none;
    // background-color: pink;
    > div:nth-child(1) {
        display: flex;
        font-size: 18rem;
        color: #fff;
    }
    > div:nth-child(2) {
        background-color: #fff;
        color: #0e6eb8;
        border-radius: 8px;
        font-size: 12rem;
        width: 70%;
        height: 40px;
        display: flex;
        justify-content: space-evenly;
        align-items: center;
        margin-top: 30rem;
    }
}
.boutique_img_box1:hover > .culture_details {
    display: block;
}
.boutique_img_box2:hover > .culture_details2 {
    display: block;
}
.top_nav {
    background-color: #f4f4f4;
    height: 100rem;
    display: flex;
    justify-content: center;
}
.nav1:hover {
    border-bottom: 4px solid #0e6eb8;
    animation: animate 2s ease-in-out infinite;
    animation-delay: calc(0.1s * var(--i));
    // animation-play-state: paused;
    animation-play-state: running;
}
.nav2:hover {
    border-bottom: 4px solid #0e6eb8;
    animation: animate 2s ease-in-out infinite;
    animation-delay: calc(0.1s * var(--i));
    // animation-play-state: paused;
    animation-play-state: running;
}
.nav3:hover {
    border-bottom: 4px solid #0e6eb8;
    animation: animate 2s ease-in-out infinite;
    animation-delay: calc(0.1s * var(--i));
    // animation-play-state: paused;
    animation-play-state: running;
}
@keyframes animate {
    0%,
    40%,
    100% {
        transform: translateY(0);
    }

    20% {
        transform: translateY(-5px);
    }
}
.nav1 {
    width: 440rem;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #333333;
    font-size: 16rem;
    font-family: Poppins;
    font-weight: bold;
    // line-height: 100rem;
}

.nav1 span {
    width: 100%;
    text-align: center;
    border-right: 1px solid #999999;
}

.nav2 {
    width: 440rem;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #333333;
    font-size: 16rem;
    font-family: Poppins;
    font-weight: bold;
    // line-height: 100rem;
}

.nav2 span {
    width: 100%;
    text-align: center;
    border-right: 1px solid #999999;
}

.nav3 {
    width: 440rem;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #333333;
    font-size: 16rem;
    font-family: Poppins;
    font-weight: bold;
    // line-height: 100rem;
}

.nav3 span {
    width: 100%;
    text-align: center;
}
.boutique_img {
    // width: 1320rem;
    width: 69%;
    height: 380rem;
    margin: 0 auto;
    display: flex;
    margin-bottom: 50px;
    // flex-wrap: wrap;
    justify-content: space-between;
}
.boutique_box {
    // width: 1320rem;
    height: 380rem;
    width: 73%;
    margin: 0 auto;
    display: flex;
}
.boutique_box2 {
    // width: 380rem;
    width: 50%;
    // height: 175rem;
    // margin: 0 auto;
    display: flex;
    // flex-wrap: wrap;
    align-content: space-between;
    justify-content: space-between;
    flex-direction: column;
}
// .boutique_img div:nth-child(1) {
//     width: 910rem;
//     height: 100%;
//     display: flex;
//     justify-content: space-between;
// }
.last_box_img {
    overflow: hidden;
    position: relative;
}
.last_box_img:hover > .culture_details2 {
    display: block;
}
.boutique_img_box1 {
    // width: 910rem;
    // width: 500rem;
    height: 100%;
    display: flex;
    justify-content: space-between;
    margin-right: 30rem;
    overflow: hidden;
    position: relative;
}

.boutique_img_box2 {
    // width: 910rem;
    // width: 500rem;
    height: 175rem;
    display: flex;
    justify-content: space-between;
    overflow: hidden;
    position: relative;

    // margin-right: 30rem;
    // > div:nth-child(2) {
    //     width: 380rem;
    //     height: 380rem;
    // }
}
// .boutique_img div:nth-child(2) {
//     width: 410rem;
//     display: flex;
//     flex-wrap: wrap;
//     justify-content: flex-end;
//     align-content: space-between;
// }

.detils {
    position: relative;
    height: 388rem;
}
.mores {
    font-size: 16rem;
    background-color: #0e6eb8;
    // width: 152rem;
    width: 11%;
    height: 58rem;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 5rem;
}
.mores:hover {
    color: #fff !important;
}
.mores div {
    position: relative;
    right: -6%;
    top: 3%;
}

.berich {
    width: 615rem;
    color: rgba(101, 101, 101, 1);
    font-size: 14rem;
    margin-top: 15rem;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 8;
    line-clamp: 8;
    -webkit-box-orient: vertical;
}

.playimg {
    position: absolute;
    width: 60rem;
    height: 60rem;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 13 !important;
    background-image: url('/static/images/play.png');
}

.imgsty {
    width: 415rem;
    height: 388rem;
    border-radius: 10rem;
}

.carsty {
    display: flex;
    justify-content: space-between;
}

.curtain {
    width: 60%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin: 0 auto;

    &::after {
        content: '';
        width: 370rem;
    }

    > div {
        width: 370rem;
        height: 200rem;
        background: #fff;
        border-radius: 8rem;
        margin-top: 30rem;
        border-radius: 8px;
        padding: 24rem 30rem;
        box-sizing: border-box;
    }
}

.mainbox {
    > div {
        width: 60%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 190rem auto 0;
    }

    > div:nth-child(even) {
        display: flex;
        flex-direction: row-reverse;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/boutique.vue